/**
 * Wheelchair Accessibility Icon
 * 
 * International Symbol of Access (ISA) indicating wheelchair accessibility.
 * Uses Font Awesome for consistent, maintained icons.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWheelchair } from '@fortawesome/free-solid-svg-icons/faWheelchair';
import type { IconProps } from '../../types';

export function WheelchairIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Wheelchair Accessible',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faWheelchair}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
